import { SpecificationEnum } from '../../models/specification.enum';
import { MaterialEnum } from '../../models/material.enum';
import { UnitTypesInBridge } from '@modules/teeth-diagram/models/unit-type-in-bridge.enum';
import { procedureMapComposites } from '../../models/procedure-map-composites';
import { ProcedureSpecificationMaterialRule, SpecificationRule } from '../../models/specification-material-rules-config';

const baseTemporaryMaterials: readonly MaterialEnum[] = [
	MaterialEnum.ResinAcrylicPMMA,
	MaterialEnum.PolymerPEEK,
	MaterialEnum.Composite,
	MaterialEnum.OtherCheckNote
];

const baseFullContourMaterials: readonly MaterialEnum[] = [
	MaterialEnum.CeramicZirconia,
	MaterialEnum.CeramicTranslucentZirconia,
	MaterialEnum.CeramicMultilayerZirconia,
	MaterialEnum.CeramicLithiumDisilicate,
	MaterialEnum.CeramicLabPreference,
	MaterialEnum.MetalHighNoble,
	MaterialEnum.MetalSemiPrecious,
	MaterialEnum.MetalTitanium,
	MaterialEnum.MetalCobaltChrome,
	MaterialEnum.ResinAcrylicPMMA,
	MaterialEnum.PolymerPEEK,
	MaterialEnum.OtherCheckNote
];

const basePfmPfzMaterials: readonly MaterialEnum[] = [
	MaterialEnum.CeramicZirconia,
	MaterialEnum.CeramicTranslucentZirconia,
	MaterialEnum.CeramicMultilayerZirconia,
	MaterialEnum.CeramicLithiumDisilicate,
	MaterialEnum.CeramicLabPreference,
	MaterialEnum.MetalHighNoble,
	MaterialEnum.MetalSemiPrecious,
	MaterialEnum.MetalTitanium,
	MaterialEnum.MetalCobaltChrome,
	MaterialEnum.OtherCheckNote
];

const baseCopingOnlyMaterials: readonly MaterialEnum[] = [
	MaterialEnum.CeramicZirconia,
	MaterialEnum.CeramicTranslucentZirconia,
	MaterialEnum.CeramicLithiumDisilicate,
	MaterialEnum.CeramicLabPreference,
	MaterialEnum.PolymerPEEK,
	MaterialEnum.OtherCheckNote
];

const specifications: SpecificationRule[] = [
	{
		Id: SpecificationEnum.FullContour,
		Materials: [...baseFullContourMaterials]
	},
	{
		Id: SpecificationEnum.PFM_PFZ,
		Materials: [...basePfmPfzMaterials]
	},
	{
		Id: SpecificationEnum.PFM_PFZ_CopingOnly,
		Materials: [...baseCopingOnlyMaterials]
	},
	{
		Id: SpecificationEnum.Temporary,
		Materials: [...baseTemporaryMaterials]
	}
];

export const rulesForBridgeFixedRestorative: ProcedureSpecificationMaterialRule = {
	ProcedureMaps: [procedureMapComposites.fixedRestorativeAll],
	UnitTypeRules: [
		{
			Id: UnitTypesInBridge.Abutment,
			Specifications: [
				{
					Id: SpecificationEnum.FullContour,
					Materials: [...baseFullContourMaterials]
				},
				{
					Id: SpecificationEnum.PFM_PFZ,
					Materials: [
						MaterialEnum.CeramicZirconia,
						MaterialEnum.CeramicLithiumDisilicate,
						MaterialEnum.CeramicLabPreference,
						MaterialEnum.MetalHighNoble,
						MaterialEnum.MetalSemiPrecious,
						MaterialEnum.MetalTitanium,
						MaterialEnum.MetalCobaltChrome,
						MaterialEnum.OtherCheckNote
					]
				},
				{
					Id: SpecificationEnum.PFM_PFZ_CopingOnly,
					Materials: [...baseCopingOnlyMaterials]
				},
				{
					Id: SpecificationEnum.Temporary,
					Materials: [...baseTemporaryMaterials]
				}
			]
		},
		{
			Id: UnitTypesInBridge.Pontic,
			Specifications: specifications
		},
		{
			Id: UnitTypesInBridge.Maryland,
			Specifications: specifications
		},
		{
			Id: UnitTypesInBridge.ImplantBased,
			Specifications: specifications
		},
		{
			Id: UnitTypesInBridge.EggshellBridge,
			Specifications: [
				{
					Id: SpecificationEnum.Temporary,
					Materials: [...baseTemporaryMaterials]
				}
			]
		},
		{
			Id: UnitTypesInBridge.MockupBridge,
			Specifications: [
				{
					Id: SpecificationEnum.Temporary,
					Materials: [...baseTemporaryMaterials]
				}
			]
		},
		{
			Id: UnitTypesInBridge.Inlay,
			Specifications: specifications
		},
		{
			Id: UnitTypesInBridge.Onlay,
			Specifications: specifications
		}
	]
};
